<template>
  <div style="background-color: #f6f5f5">
    <template v-if="!isMobile">
      <v-alert v-if="!isReadInfo" text type="info">
        <div class="black--text">
          Jika sudah puas dengan kuesioner Anda, jangan lupa untuk menyimpannya dengan mengklik tombol 'Simpan'.
        </div>
      </v-alert>
    </template>

    <v-card>
      <v-card-text class="pa-5 black--text">
        <div class="text-h5">
          {{ getDeepObj(info, 'nama') || 'Judul Kuesioner' }}
        </div>
        <div>
          {{ getDeepObj(info, 'deskripsi') || 'deskripsi' }}
        </div>
        <div :class="`${$vuetify.breakpoint.xsOnly ? '' : 'd-flex justify-space-between'} pt-5`">
          <v-sheet>
            <v-list-item class="px-0">
              <v-list-item-avatar color="primary">
                <v-icon dark>mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <div class="body-1 black--text">
                  {{ getDeepObj(info, 'user.nama') || getDeepObj(user, 'nama') || '' }}
                </div>
                <p class="caption black--text">
                  <span>{{ getDeepObj(info, 'user.email') || getDeepObj(user, 'email') || '' }}</span>
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-sheet>
          <v-sheet>
            <v-list-item class="px-0">
              <v-list-item-avatar tile>
                <v-icon size="30">mdi-city</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <div class="black--text">
                  {{ getDeepObj(info, 'organisasi.nama') || getDeepObj(organisasi, 'nama') || '' }}
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-sheet>
        </div>
      </v-card-text>
    </v-card>
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-card
        v-for="(survey, s) in surveyList"
        :key="s"
        v-if="survey.label || survey.k_tipe_soal"
        class="mt-5 rounded-lg"
      >
        <v-card-text class="black--text">
          <div class="mt-2 mb-2 text-subtitle-1"> {{ getDeepObj(survey, 'label') }}</div>
          <v-alert
            type="error"
            text
            v-if="(errors.collect(`form.${isStep ? `survey_${page - 1}` : 'survey_' + (s + 1)}`) || []).length > 0"
          >
            <div>
              {{ getDeepObj(errors.collect(`form.${isStep ? `survey_${page - 1}` : 'survey_' + (s + 1)}`), '0') }}
            </div>
          </v-alert>
          <template v-if="survey.k_tipe_soal">
            <v-textarea
              v-if="survey.k_tipe_soal == 4"
              v-model="survey.text"
              outlined
              dense
              counter="60"
              rows="1"
              placeholder="Jawabah Anda"
              :data-vv-name="isStep ? `survey_${page}` : `survey_${s + 1}`"
              :data-vv-as="isStep ? `Pertanyaan ke ${page}` : `Pertanyaan ke ${s + 1}`"
              v-validate="survey && survey.is_required ? `required|max:60` : 'max:60'"
              @input="emitText(survey)"
            ></v-textarea>
            <v-textarea
              v-else-if="survey.k_tipe_soal == 5"
              v-model="survey.text"
              outlined
              dense
              placeholder="Jawaban Anda"
              rows="3"
              counter="100"
              :data-vv-name="isStep ? `survey_${page}` : `survey_${s + 1}`"
              :data-vv-as="isStep ? `Pertanyaan ke ${page}` : `Pertanyaan ke ${s + 1}`"
              v-validate="survey && survey.is_required ? 'required|max:100' : 'max:100'"
              @input="emitText(survey)"
            ></v-textarea>
            <v-select
              v-else-if="survey.k_tipe_soal == 3"
              v-model="survey.result"
              outlined
              dense
              :items="survey.opsi"
              item-value="label"
              item-text="label"
              placeholder="Pilihan Anda"
              style="width: 50%"
              :data-vv-name="isStep ? `survey_${page}` : `survey_${s + 1}`"
              :data-vv-as="isStep ? `Pertanyaan ke ${page}` : `Pertanyaan ke ${s + 1}`"
              v-validate="survey && survey.is_required ? 'required' : ''"
              @change="$emit('answer', survey)"
            >
            </v-select>
            <v-radio-group
              v-else-if="survey.k_tipe_soal === 1"
              v-model="survey.result"
              :data-vv-name="isStep ? `survey_${page}` : `survey_${s + 1}`"
              :data-vv-as="isStep ? `Pertanyaan ke ${page}` : `Pertanyaan ke ${s + 1}`"
              v-validate="survey && survey.is_required ? 'required' : ''"
              @change="$emit('answer', survey)"
            >
              <v-radio
                v-for="(op, o) in survey.opsi"
                :key="o"
                class="caption"
                :label="op.label"
                :value="op.label"
              ></v-radio>
            </v-radio-group>
            <template v-else-if="survey.k_tipe_soal == 2">
              <v-checkbox
                v-model="survey.result"
                dense
                multiple
                hide-details
                v-for="(op, o) in survey.opsi"
                :key="o"
                :value="op.label"
                :label="op.label"
                :data-vv-name="isStep ? `survey_${page}` : `survey_${s + 1}`"
                :data-vv-as="isStep ? `Pertanyaan ke ${page}` : `Pertanyaan ke ${s + 1}`"
                v-validate="survey && survey.is_required ? 'required' : ''"
                @change="emitText(survey)"
              />
            </template>
            <v-text-field
              v-if="
                (getDeepObj(survey, 'result') === 'Lainnya...' ||
                  (getDeepObj(survey, 'result') || []).includes('Lainnya...')) &&
                ![4, 5].includes(survey.k_tipe_soal)
              "
              v-model="survey.catatan"
              class="mt-n2"
              dense
              hint="Isikan pilihan lainnya"
              persistent-hint
              @input="emitText(survey)"
            ></v-text-field>
          </template>
        </v-card-text>
      </v-card>
    </v-form>
    <div
      v-if="Number(Number(getDeepObj(info, 'is_wizard') || 0) === 1)"
      class="text-right mt-10 mb-5"
      style="background-color: #f6f5f5"
    >
      <v-btn v-if="page > 1" class="mx-1" outlined color="primary" @click="page--"> Sebelumnya </v-btn>
      <v-btn v-if="page < surveys.length" color="primary" @click="nextStep"> Berikutnya </v-btn>
      <v-btn v-if="page === surveys.length && isMobile" color="primary" @click="save"> Kirim </v-btn>
    </div>
    <div v-else-if="isMobile" class="text-right mt-10 mb-5" style="background-color: #f6f5f5">
      <v-btn color="primary" @click="save"> Kirim </v-btn>
    </div>
    <div :class="`d-flex pa-3 text-center primary white--text caption ${isMobile ? 'bg-bottom' : 'bg-bottom-edit'}`">
      {{ isStep ? page : resultCount() }}
      <v-progress-linear
        class="mx-2 mt-1"
        rounded
        height="10"
        color="orange"
        background-color="white"
        :value="precentage()"
        style="width: 50%"
      ></v-progress-linear>
      <span>{{ surveys.length }} Kuesioner</span>
    </div>
    <v-dialog persistent v-model="dialog" width="400">
      <v-card>
        <v-card-text class="text-center pa-5 black--text">
          <v-avatar size="50" color="green">
            <v-icon size="40" color="white">mdi-check</v-icon>
          </v-avatar>
          <p class="white--text"> &#x2660;</p>
          <div class="text-h6 mt-4"> Jawaban Terkirim </div>
          <div> Jawaban Anda telah kami simpan, Terimakasih atas respon Anda </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  $_veeValidate: {
    validator: 'new',
  },

  props: {
    info: {
      type: Object,
      default: () => {},
    },
    surveys: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isReadInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      page: 1,
      limit: 1,
      debounce: null,
    }
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user || {},
    }),

    ...mapState('organisasi', {
      organisasi: (state) => state.organisasiAktif || {},
    }),

    isStep() {
      return Number(Number(this.getDeepObj(this.info, 'is_wizard') || 0)) === 1
    },
    surveyList() {
      if (Number(this.getDeepObj(this.info, 'is_wizard')) !== 1) {
        return this.surveys
      }
      const start = this.page === 1 ? 0 : this.limit * (this.page - 1)
      const finish =
        this.page === 1
          ? this.limit
          : this.surveys.length > this.page * this.limit
          ? this.page * this.limit
          : this.surveys.length
      return this.surveys.slice(start, finish)
    },
  },
  methods: {
    reset() {
      this.$validator.reset()
    },

    resultCount() {
      let count = 0
      this.surveys.forEach((item) => {
        if (Number(item.k_tipe_soal) > 3) {
          if (!['', null, undefined].includes(item.text)) {
            count += 1
          }
        } else {
          if (Number(item.k_tipe_soal) === 2) {
            const res = item.result || []
            if (res.length > 0) count += 1
          } else if (!['', null, undefined, []].includes(item.result)) {
            count += 1
          }
        }
      })

      return count
    },

    precentage() {
      const page = this.isStep ? this.page : Number(this.resultCount())
      const max = this.surveys.length || 0
      return (page / max) * 100
    },

    nextStep() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.page++
        })
    },

    async save() {
      const validate = await this.$validator.validateAll('form')
      if (!validate) return
      this.$emit('save', this.surveys)
    },

    emitText(item) {
      clearTimeout(this.debouce)
      this.debouce = setTimeout(() => {
        this.$emit('answer', item)
      }, 1500)
    },
  },
  watch: {
    surveys() {
      this.resultCount()
    },
    deep: true,
  },
}
</script>
<style scoped>
.bg-bottom {
  position: fixed;
  bottom: 0;
  width: 60%;
  left: 20%;
  right: 20%;
  display: flex;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  text-align: center;
  justify-content: center !important;
}

.bg-bottom-edit {
  position: fixed;
  width: 20%;
  bottom: 0;
  left: 40%;
  right: 40%;
  display: flex;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  text-align: center;
  justify-content: center !important;
}
</style>
